export const DATATABLE_TOOLBAR_CONTROL_HEIGHT_CLASS = 'h-9';
export const DATATABLE_TOOLBAR_ICON_BUTTON_SIZE_CLASS = 'h-9 w-9';
export const DATATABLE_SIZE_OPTION_MEDIUM = 'medium';
export const DATATABLE_SIZE_OPTIONS = [
  { label: 'S', value: 'small' },
  { label: 'M', value: DATATABLE_SIZE_OPTION_MEDIUM },
  { label: 'L', value: 'large' },
];
